import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { CaptchaV3ConfigModel } from '../../Core/models';
import { StartUpConfigUiService, CaptchaV3UIService, CookieService } from '../../Core/Services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'ras-recaptchav3',
  templateUrl: './captcha-v3.component.html',
  styles: ['.grecaptcha-badge{ visibility:hidden; }'],
  encapsulation: ViewEncapsulation.None
})
export class ReCaptchaV3Component implements OnInit {

  private siteKey = "";
  private captchaSettings: CaptchaV3ConfigModel;

  constructor(
    private startUpConfigUiService: StartUpConfigUiService,
    private reCaptchaV3Service: CaptchaV3UIService,
    private cookieService: CookieService) { }


  ngOnInit() {
    this.startUpConfigUiService.sessionInfo$.subscribe({
      next: (sessionInfo) => {
        if (!sessionInfo.isMobileApp) {
          this.startUpConfigUiService.deferredConfig$.pipe(take(1)).subscribe({
            next: (deferredConfig) => {

              this.captchaSettings = deferredConfig.captchaV3Settings;
              if (!this.captchaSettings)
                return;

              if (!this.captchaSettings.isEnabled)
                return;

              this.siteKey = this.captchaSettings.settings.siteKey;

              this.reCaptchaV3Service.init(this.siteKey, { action: 'homepage' }).then(response => {

                //just to make sure Captcha Client Api gets load before going to get token
                //setTimeout(() => {
                //    this.getToken();
                //}, 3000);
                this.subscribeTokenProvider(sessionInfo.isWhiteLabel);
                //this.reCaptchaV3Service.hideCaptcha();
              });
            }
          });
        }
      }
    });
  }

  subscribeTokenProvider(isWL: boolean) {
    this.reCaptchaV3Service.CaptchaTokenSubject.pipe(take(1)).subscribe(token => {

      //Get value from cookie to check if already stored for the same session
      var IsNewSession = this.CheckIfNewSession(this.captchaSettings.settings.cookieKey);
      if (IsNewSession) {
        //Set value to cookie to prevent the same session entry
        if (!isWL)
          this.cookieService.set(this.captchaSettings.settings.cookieKey, 'true', 1, '', this.captchaSettings.settings.cookieDomain);
        else
          this.cookieService.set(this.captchaSettings.settings.cookieKey, 'true', 1, '', this.captchaSettings.settings.cookieDomain, true, 'None');

        this.VerifyTokenAndSaveScore(token);
        // this.reCaptchaV3Service.hideCaptcha();
      }
    });
  }

  getToken() {
    this.reCaptchaV3Service.getToken({ action: 'homepage' }).then(token => {
      //Get value from cookie to check if already stored for the same session
      var IsNewSession = this.CheckIfNewSession(this.captchaSettings.settings.cookieKey);
      if (IsNewSession) {
        //Set value to cookie to prevent the same session entry
        this.cookieService.set(this.captchaSettings.settings.cookieKey, 'true', 1);

        this.VerifyTokenAndSaveScore(token);
        //this.reCaptchaV3Service.hideCaptcha();
      }
    });
  }

  VerifyTokenAndSaveScore(token) {
    //Get score with token and save 
    this.reCaptchaV3Service
      .validateCaptchaToken(token)
      .pipe(take(1)).subscribe(r => {
        console.log("captcha validated");
      }, err => console.log('HTTP Error (VerifyTokenAndSaveScore): ', err));
  }

  CheckIfNewSession(key): boolean {
    return this.cookieService.get(key) === "false" || this.cookieService.get(key) === "" ? true : false;
  }
}
